<script setup lang="ts">
    const { te, t } = useLocales();
    const localePath = useLocalePathWoom();
    const lookupKey = 'page.newsletterUrl';
    const newsletterLink = computed(() => te(lookupKey) && t(lookupKey));
</script>
<template>
    <nuxt-link
        v-if="newsletterLink"
        :to="localePath(newsletterLink)"
        class="atm-newsletter-button gap-3 text-base transition-colors hover:text-woom-red max-lg:flex max-lg:items-center max-lg:py-3 lg:p-1">
        {{ $t('newsletterSignup') }}
    </nuxt-link>
</template>
